import React from 'react';
import StepHeading from './StepHeading';
import { noAutofill } from '../noAutofill';

interface Step1Props {
  userName: string;
  setUserName: (name: string) => void;
  onEnterPress: () => void;
  loading: boolean;
}

const Step1: React.FC<Step1Props> = ({ userName, setUserName, onEnterPress, loading }) => (
  <div className="ed-enter">
    <StepHeading
      index={1}
      kicker="Product Studio"
      title="Design a product the world"
      accent="hasn't seen yet."
      lede="Name it, photograph it, write it, price it, and publish it to the SuperPossible storefront. Start by telling us who is behind the work."
    />

    <div className="ed-block ed-block--sheet">
      <label className="ed-label" htmlFor="creator-name">
        Your name
      </label>
      <input
        id="creator-name"
        type="text"
        className="ed-input ed-input--display"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && userName.trim() && !loading) onEnterPress();
        }}
        placeholder="Type your name"
        {...noAutofill}
      />
      <p className="ed-hint">Press Enter to begin.</p>
    </div>
  </div>
);

export default Step1;
